import HomePage from './Page/HomePage';
import './App.css';

function App() {
  return (
    <>
    <HomePage />

    </>
  );
}

export default App;
